import { buttonVariants } from '@design-system/button';
import { cn } from '@design-system/helpers';
import { Progress } from '@design-system/progress-bar';
import { formatByteSize } from '@features/settings/pages/billing/pricing/format-by-size';
import { Flashy } from 'iconsax-react';
import type { FC } from 'react';

// const displayedAddon = ['Leads', 'Invoices', 'Tasks', 'Storage', 'WhatsApp Reminders', 'Email Questions', 'SMS Reminders'];

const AddonItem: FC<{ name: string; totalCount: number; count: number }> = ({
  count,
  name,
  totalCount,
}) => {
  return (
    <div className='border border-primary-200 p-4 rounded-xl w-full mb-2 hover:bg-primary-30 cursor-pointer relative group'>
      <div className='flex justify-between items-center mb-3'>
        <p className='font-medium text-gray-800 text-sm'>{name}</p>
        <p className='text-sm font-normal text-gray-600'>
          {/* Will be changed from BE side */}(
          {name === 'Storage' ? formatByteSize(count) : count}/
          {name === 'Storage' ? formatByteSize(totalCount) : totalCount})
        </p>
      </div>
      <Progress value={(count / totalCount) * 100} />
      <div
        className={cn(
          buttonVariants({ variant: 'warning', size: 'sm' }),
          'rounded-full absolute left-1/2 -translate-x-1/2 -bottom-5 hidden group-hover:flex'
        )}
      >
        <Flashy className='mr-1' />
        Add on
      </div>
    </div>
  );
};

export default AddonItem;
